import React, {useState} from 'react'
import CTAButton from './CTAButton'
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles({
    countdownSection: {
        paddingTop: '80px',
        paddingBottom: '80px',
        // backgroundColor: '#f0f1f3',
        textAlign: 'center',
    },
    countdownContainer: {
        maxWidth: '1000px',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    countdownHeader: {
        '& h2': {
            marginBottom: '40px'
        }
    },
    countdownItem: {
        padding: '25px 10px',
        backgroundColor: 'white',
        borderRadius: '20px',
        border: '1px solid var(--primary-color)',
        '@media screen and (max-width: 768px)': {
            padding: '15px 5px',
            '& h1': {
                fontSize: '20px',
            },
            '& h4': {
                fontSize: '14px',
            },
        }
    },
    countdownBody: {
        '& .col-3': {
            paddingRight: 'calc(var(--bs-gutter-x) * 0.2)',
            paddingLeft: 'calc(var(--bs-gutter-x) * 0.2)'
        }
    }
});

function Countdown() {

    const countDownDate = new Date("Jan 5, 3022 24:00:00").getTime();

    const [[h, m, s], setTime] = useState([0, 0, 0]);
        
    var x = setTimeout(function() {
    
        var now = new Date().getTime();
        
        var distance = countDownDate - now;
        
        // var days = 0;
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        setTime([hours, minutes, seconds])
        
        if (distance <= 0) {
            clearTimeout(x);
        }
    }, 1000);

    const classes = useStyles()

    return (
        <div className={classes.countdownSection}>
            <div className="container">
                <div className={classes.countdownContainer}>
                    <div className={classes.countdownHeader}>
                        <h2>Time Is Running Out. Grab Your Spot Fast!</h2>
                    </div>
                    <div className={classes.countdownBody}>
                        <div className="row">
                            <div className="col-3">
                                <div className={classes.countdownItem}>
                                    <h1 id="day-timer">0</h1>
                                    <h4>Days</h4>
                                </div>
                            </div>
                            <div className="col-3">
                                <div className={classes.countdownItem}>
                                    <h1 id="hour-timer">{h}</h1>
                                    <h4>Hours</h4>
                                </div>
                            </div>
                            <div className="col-3">
                                <div className={classes.countdownItem}>
                                    <h1 id="minute-timer">{m}</h1>
                                    <h4>Minutes</h4>
                                </div>
                            </div>
                            <div className="col-3">
                                <div className={classes.countdownItem}>
                                    <h1 id="second-timer">{s}</h1>
                                    <h4>Seconds</h4>
                                </div>
                            </div>
                        </div>

                        <CTAButton/>

                    </div>
                </div>
            </div>
        </div>
    )
}

export default Countdown
